module.exports = __webpack_public_path__ + "img/01.bd652505.jpg";